import type {
  PriceEstimatePropertyDetailsDto,
  PropertyAddressSuggestionsDto,
} from "@unreserved/sdk";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export interface GetEstimatesStoreState {
  selectedProperty: PropertyAddressSuggestionsDto | null;
  propertyData: PriceEstimatePropertyDetailsDto | null;
  improvementsData: {
    hasRenovations: boolean;
    description: string;
    files: File[];
  } | null;
  currentStep: number;
  cameFromLandingPage: boolean;
}

export interface GetEstimatesStore extends GetEstimatesStoreState {
  setSelectedProperty: (property: PropertyAddressSuggestionsDto | null) => void;
  setPropertyData: (data: PriceEstimatePropertyDetailsDto | null) => void;
  setImprovementsData: (
    data: {
      hasRenovations: boolean;
      description: string;
      files: File[];
    } | null,
  ) => void;
  setCurrentStep: (step: number) => void;
  setCameFromLandingPage: (came: boolean) => void;
  resetStore: () => void;
}

const initialState: GetEstimatesStoreState = {
  selectedProperty: null,
  propertyData: null,
  improvementsData: null,
  currentStep: 1,
  cameFromLandingPage: false,
};

export const useGetEstimatesStore = create<GetEstimatesStore>()(
  devtools(
    (set) => ({
      ...initialState,

      setSelectedProperty: (property) => {
        set({ selectedProperty: property });
      },

      setPropertyData: (data) => {
        set({ propertyData: data });
      },

      setImprovementsData: (data) => {
        set({ improvementsData: data });
      },

      setCurrentStep: (step) => {
        set({ currentStep: step });
      },

      setCameFromLandingPage: (came) => {
        set({ cameFromLandingPage: came });
      },

      resetStore: () => {
        set(initialState);
      },
    }),
    {
      name: "get-estimates-store",
      enabled: process.env.NODE_ENV === "development",
    },
  ),
);
